import * as React from 'react';

import { useSetAtom } from 'jotai';

import { $populateCategoryFormAction } from '../_state/categoryForm.state';
import { CategoryRecord } from '../types/inventoryItem';

type Props = {
  category: CategoryRecord | null | undefined;
};

export const usePopulateCategoryForm = ({ category }: Props) => {
  const populateForm = useSetAtom($populateCategoryFormAction);

  React.useEffect(() => {
    populateForm(category);
  }, [category, populateForm]);
};
